<template>
  <div>
    <switches
        v-model="showMoney"
        theme="bulma"
        color="blue"
        text-enabled="Hide money"
        text-disabled="Show money"/>
    <!--Stats cards-->
    <div class="row">
      <div
          class="col-lg-4 col-md-6 col-sm-6 clickable"
          v-for="(item, index) in plan" :key="index"
          @click="goTo(item.path)">
        <stats-card :type="item.type"
                    :icon="item.icon"
                    :small-title="item.title"
                    :title="item.value"
                    :showMoney="showMoney"
                    :hasMoney="item.generalIsMoney">
          <div class="stats" slot="footer" :class="[!showMoney && item.secondaryIsMoney ? 'blur' : '']">
            <i :class="item.footerIcon"></i>
            {{item.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row ">
      <div
          class="col-lg-4 col-md-6 col-sm-6 grayscale"
          v-for="(item, index) in act" :key="index">
        <stats-card :type="item.type"
                    :icon="item.icon"
                    :small-title="item.title"
                    :title="item.value"
                    :showMoney="showMoney"
                    :hasMoney="item.generalIsMoney">
          <div class="stats" slot="footer" :class="[!showMoney && item.secondaryIsMoney ? 'blur' : '']">
            <i :class="item.footerIcon"></i>
            {{item.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div
          class="col-lg-4 col-md-6 col-sm-6 grayscale"
          v-for="(item, index) in grow" :key="index">
        <stats-card :type="item.type"
                    :icon="item.icon"
                    :small-title="item.title"
                    :title="item.value"
                    :showMoney="showMoney"
                    :hasMoney="item.generalIsMoney">
          <div class="stats" slot="footer" :class="[!showMoney && item.secondaryIsMoney ? 'blur' : '']">
            <i :class="item.footerIcon"></i>
            {{item.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    <modal :show.sync="showModal"
           footer-classes="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">How Do You Use This Screen?</h5>
      <template>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>See your info all in one place</strong>
              <p class="description">
                Your dashboard gives you a summary of each area of the system at a glance. Cards start off as dark grey
                and turn green as you enter data.  Click the card to go directly to the screen it represents.
              </p>
            </div>
          </div>
        </div>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Keep your business to yourself</strong>
              <p class="description">
                We hide any values which represent dollar figures since we never know who's looking over your shoulder.
                Click the Show money switch to display the values.
              </p>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer" class="justify-content-center">
        <p-button type="info" round @click.native="showModal = false">Got it!</p-button>
      </div>
    </modal>
  </div>
</template>


<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import {Badge} from 'src/components/UIComponents'
  import TaskList from 'src/components/Common/Views/Dashboard/Widgets/TaskList'
  import { getDashboardAPI } from 'src/api/api'
  import { mapActions } from 'vuex'
  import { Auth, Analytics } from "aws-amplify";
  import Switches from 'vue-switches';
  import Modal from "../UIComponents/Modal";

  const completed = c => c ? 'success' : 'secondary';

  export default {
    async beforeCreate() {
      try {
        let account = await Auth.currentAuthenticatedUser();
        this.$store.commit('saveUser', account);
      } catch (e) {}
    },
    created() {
      this.setNavbarTitle('Dashboard');
    },
    async mounted() {
      let dashboardData = await getDashboardAPI();

      const timeCompleted = dashboardData.Plan.Time.completed == "true";
      const incomeCompleted = dashboardData.Plan.Income.completed == "true";
      const projectsCompleted = dashboardData.Plan.Projects.completed == "true";

      const dataEntered = timeCompleted || incomeCompleted || projectsCompleted;

      this.showModal = !dataEntered;

      this.plan = [
        {
          type: completed(dashboardData.Plan.Income.completed == "true"),
          icon: 'fas fa-chart-line',
          title: 'Income',
          value: `${dashboardData.Plan.Income.earned_last_month.toLocaleString()}`,
          footerText: `${dashboardData.Plan.Income.effective_rate.toFixed(2)} - effective rate`,
          footerIcon: 'fas fa-dollar-sign',
          generalIsMoney: true,
          secondaryIsMoney: true,
          path: '/plan/income'
        },
        {
          type: completed(dashboardData.Plan.Time.completed == "true"),
          icon: 'fas fa-clock',
          title: 'Time',
          value: `${dashboardData.Plan.Time.available_hours}`,
          footerText: `${dashboardData.Plan.Time.potential_earnings.toLocaleString()} - potential earnings`,
          footerIcon: 'fas fa-dollar-sign',
          generalIsMoney: false,
          secondaryIsMoney: true,
          path: '/plan/time'
        },
        {
          type: completed(dashboardData.Plan.Projects.completed == "true"),
          icon: 'fas fa-project-diagram',
          title: 'Projects',
          value: `${dashboardData.Plan.Projects.active_projects}`,
          footerText: `${dashboardData.Plan.Projects.potential_projects} - potential projects`,
          footerIcon: 'fas fa-briefcase',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/plan/projects'
        }
      ];

      this.act = [
        {
          type: completed(dashboardData.Act['Daily Dev Log'].completed),
          icon: 'fas fa-file-signature',
          title: 'Daily Dev Log',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/act/dailydevlog'
        },
        {
          type: completed(dashboardData.Act.Reading.completed),
          icon: 'fas fa-book-reader',
          title: 'Reading',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/act/whatiread'
        },
        {
          type: completed(dashboardData.Act['Manager Access'].completed),
          icon: 'fas fa-users',
          title: 'Manager Access',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/act/manageraccess'
        },
      ];

      this.grow = [
        {
          type: completed(dashboardData.Grow.Stengths.completed),
          icon: 'fas fa-dumbbell',
          title: 'Strengths',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/grow/strengthsopportunities'
        },
        {
          type: completed(dashboardData.Grow.Focus.completed),
          icon: 'fas fa-bullseye-arrow',
          title: 'Focus',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/grow/currentfocus'
        },
        {
          type: completed(dashboardData.Grow['Public Profile'].completed),
          icon: 'fas fa-user-edit',
          title: 'Public Profile',
          value: ``,
          footerText: `coming soon`,
          footerIcon: 'fas fa-lock',
          generalIsMoney: false,
          secondaryIsMoney: false,
          path: '/account/profile'
        },
      ];
    },

    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      Badge,
      TaskList,
      Switches,
      Modal
    },
    data () {
      return {
        showModal: false,
        showMoney: false,
        plan: [],
        act: [],
        grow: []
      }
    },

    methods: {
      ...mapActions('UI', ['setNavbarTitle']),

      goTo(path) {
        console.log(path);
        this.$router.push(path);
      }
    }
  }

</script>

<style lang="scss" scoped>
  .blur {
    filter: blur(4px);
  }
  .clickable {
    cursor: pointer;
  }
  .clickable > .card {
    border-radius: 4px !important;
  }
  .grayscale {
    filter: grayscale(100%);
    opacity: .5;
  }
</style>
